import { IsEnum } from 'class-validator';
import { NamedEntityDto } from '../clinical-details';
import { UrgencyRating } from '@dermloop/static-values';

export class UrgencyRatingDto extends NamedEntityDto {
  @IsEnum(UrgencyRating)
  urgencyRating: UrgencyRating;
}
